import { type PropsWithChildren, useMemo } from 'react';

import type { FeatureToggles } from './FeatureToggleContext';
import { createToggles, defaultFeatureToggles, FeatureToggleContext } from './FeatureToggleContext';

export interface FeatureToggleProps extends PropsWithChildren {
    featureToggles?: FeatureToggles;
}
export const FeatureToggleProvider = ({
    children,
    featureToggles: initialToggles = defaultFeatureToggles,
}: FeatureToggleProps) => {
    const featureToggles = useMemo(() => {
        const toggles = createToggles(initialToggles);

        if (toggles.logToggles) {
            console.table(toggles);
        }

        return toggles;
    }, [initialToggles]);

    return <FeatureToggleContext value={featureToggles}>{children}</FeatureToggleContext>;
};
